import { render, staticRenderFns } from "./PointPicker.vue?vue&type=template&id=12acb87a"
import script from "./PointPicker.vue?vue&type=script&lang=js"
export * from "./PointPicker.vue?vue&type=script&lang=js"
import style0 from "./PointPicker.vue?vue&type=style&index=0&id=12acb87a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports